import {Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

type Props = {
    open: boolean;
    title?: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    errorMessage?: string;
    onConfirm: () => void;
    onClose: () => void;
    isLoading?: boolean;
};

const ConfirmDialog: React.FC<Props> = ({
    open,
    title,
    message,
    confirmLabel,
    cancelLabel,
    errorMessage,
    onConfirm,
    onClose,
    isLoading = false,
}) => {
    return (
        <Dialog open={open} onClose={isLoading ? undefined : onClose} fullWidth maxWidth="xs">
            {title ? <DialogTitle>{title}</DialogTitle> : null}
            <DialogContent>
                {errorMessage ? (
                    <Alert severity="error" sx={{mb: 2}}>
                        {errorMessage}
                    </Alert>
                ) : null}
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button onClick={onClose} disabled={isLoading}>
                    {cancelLabel}
                </Button>
                <Button onClick={onConfirm} variant="contained" color="error" disabled={isLoading}>
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
